module.exports = "/_next/static/images/p_cyl-d09c2ddf29b612d4f1bd544b97904d79.png";